import axios from 'axios'
import {CookiesService} from './Cookie.service'
import {AuthApi} from './AuthApi.service'
/**
 * Instância axios do módulo Carona Inteligente (carona-service, FastAPI).
 *
 * DESACOPLADO do core: em dev o carona-service aceita requisições sem token
 * (bypass DEV_AUTH_KEY). Por isso NÃO anexamos o JWT do core aqui. Se
 * VITE_CARONA_TOKEN estiver definido (ex.: saída de scripts/dev_token.py), ele é
 * enviado como Bearer para exercitar a auth real.
 */
const MyAxiosInstanceCarona = axios.create({
    baseURL: import.meta.env.VITE_CARONA_URL,
})

const cookies = new CookiesService()

MyAxiosInstanceCarona.interceptors.request.use(
    (config) => {
        let auth = cookies.getAuthData()
        config.headers.Authorization = `Bearer ${auth?.access_token}`
        return config
    },
    (error) => Promise.reject(error)
)

export default MyAxiosInstanceCarona
